var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ABusinessProfileImage"},[_c('img',{class:_vm.className,attrs:{"alt":_vm.altText,"src":_vm.fullHref,"onerror":"this.src='https://www.liffery.com/img/icons/logo-128x128.png'"},on:{"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }